import React, { useEffect, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";

import { ModalDomicilioScreen } from "./ModalDomicilioScreen";
import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";

export const DomicilioListScreen = ({ setLoading }) => {
  const { clienteselected, idcliente } = useSelector((store) => store.clientes);
  const [domicilios, setDomicilios] = useState([]);
  const [orden, setOrden] = useState(-1);
  const openModal = (value) => {
    var modal = document.getElementById("modal-domicilio");
    modal.style.display = "block";
    setOrden(value);
  };
  useEffect(() => {
    if (
      idcliente === undefined ||
      idcliente === null ||
      idcliente === 0 ||
      idcliente === "0" ||
      idcliente === "" ||
      idcliente === "-1" ||
      idcliente === "-1"
    ) {
      return;
    }
    setLoading(true);
    request
      .get(`ClientesDomicilio/Listado?idcliente=${Number(idcliente)}`)
      .then((result) => {
        setLoading(false);
        setDomicilios(result);
      })
      .catch((error) => {
        setLoading(false);
        Swal.fire("Clientes", JSON.stringify(error), "error");
      });
  }, [idcliente]);
  if (
    idcliente === undefined ||
    idcliente === null ||
    idcliente === 0 ||
    idcliente === "0" ||
    idcliente === "" ||
    idcliente === "-1" ||
    idcliente === "-1"
  ) {
    return <div>Favor de seleccionar un cliente</div>;
  }
  const capitalizeWords = (str) => {
    return str ? str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase()) : "";
  };
  return (
    <>
      <div className="clientes-domicilio-header">
        <ModalDomicilioScreen setDomicilios={setDomicilios} orden={orden} />
        <div className="clientes-domicilio-titulo">{capitalizeWords(clienteselected)}</div>
        <div
          className="clientes-domicilio-agregar"
          onClick={() => openModal(-1)}
        >
          Agregar
        </div>
      </div>
      <div className="clientes-domicilio-container scroll-4">
        {domicilios === undefined ||
        domicilios === null ||
        domicilios.length === 0 ? (
          <div className="no-data " xx>
            Sin datos registrados
          </div>
        ) : (
          <table cellPadding={0} cellSpacing={0}>
            <thead>
              <tr>
                <th>Estado</th>
                <th>Municipio</th>
                <th>Localidad</th>
                <th>C.P.</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {domicilios.map((item) => (
                <tr>
                  <td>{capitalizeWords(item.estado)}</td>
                  <td>{capitalizeWords(item.municipio)}</td>
                  <td>{capitalizeWords(item.localidad)}</td>
                  <td>{capitalizeWords(item.codigo_postal)}</td>
                  <td>
                    <div
                      className="button-editar"
                      onClick={() => openModal(item.orden)}
                    >
                      <EditIcon />
                      Editar
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </>
  );
};
